import { render, staticRenderFns } from "./VideoSwitch.vue?vue&type=template&id=bb17c012&"
import script from "./VideoSwitch.vue?vue&type=script&lang=js&"
export * from "./VideoSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports